import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";

interface Option {
  value: string;
  label: string;
}

interface FormSelectProps {
  id: string;
  label: string;
  value: string | string[] | undefined; // ✅ allow undefined
  onChange: (e: SelectChangeEvent<string | string[]>) => void;
  options: Option[];
  multiple?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
}

const FormSelect: React.FC<FormSelectProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  multiple = false,
  required = false,
  sx,
}) => {
  return (
    <FormControl fullWidth margin="normal" sx={sx}>
      <InputLabel id={`${id}-label`}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        multiple={multiple}
        value={value}
        onChange={onChange}
        required={required}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FormSelect;
